import getCountryFromHost from './getCountryFromHost.mjs'
import getCountryFromQueryString from './getCountryFromQueryString'

const getCountryFromUrl = () => {
  const defaultCountry = 'es_es'
  const countryFromHost = getCountryFromHost()
  const countryFromQueryString = getCountryFromQueryString()

  if (!countryFromHost && !countryFromQueryString) {
    return defaultCountry
  }

  if (!countryFromHost) {
    return countryFromQueryString
  }

  return countryFromHost
}

export default getCountryFromUrl
